import React, { PropTypes } from "react";
import { findDOMNode } from "react-dom";
import { Field } from "redux-form";
import { TextInput } from "../../../../common/form";
import { DragSource, DropTarget } from "react-dnd";
import flow from "lodash/flow";
import classNames from "classnames";

import { Render } from "../../../../common";

class GuaranteeLineItem extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    const {
      guarantee,
      isDragging,
      connectDragSource,
      connectDropTarget,
      connectDragPreview,
    } = this.props;
    const lineItemClasses = classNames({
      "guarantee-line-item": true,
      checked: guarantee.isActive,
      unchecked: !guarantee.isActive,
      "is-dragging": isDragging,
    });

    return connectDragPreview(
      connectDropTarget(
        <div className={lineItemClasses}>
          <div className="guarantee-name">
            <Render if={!this.props.disabled}>
              {connectDragSource(<span className="drag-handle icon-move" />)}
            </Render>
          </div>
          <div className="split-value">
            <div>
              <Field
                id={`${this.props.split}.value`}
                name={`${this.props.split}.value`}
                type="text"
                disabled={!guarantee.isActive}
                component={TextInput}
                label={guarantee.name}
                props={{
                  inputAddon: this.props.valueType === "FIXED" ? "$" : "%",
                }}
              />
            </div>
            <Field
              id={`${this.props.split}.excludedFromEmployerContribution`}
              name={`${this.props.split}.excludedFromEmployerContribution`}
              className="excluded"
              value={`${this.props.split}.excludedFromEmployerContribution`}
              disabled={!guarantee.isActive}
              // checkbox values in redux-form <7.1.0 are `true` and the empty string
              // https://github.com/redux-form/redux-form/issues/3162
              normalize={(val) => !!val}
              component="input"
              type="checkbox"
            />
          </div>
        </div>
      )
    );
  }
}

GuaranteeLineItem.propTypes = {
  disabled: PropTypes.bool,
  valueType: PropTypes.string,
};

const guaranteeSource = {
  beginDrag(props) {
    return {
      index: props.index,
      listId: props.listId,
      guarantee: props.guarantee,
    };
  },

  endDrag(props, monitor) {
    const item = monitor.getItem();
    const dropResult = monitor.getDropResult();

    if (dropResult && dropResult.listId !== item.listId) {
      props.removeGuarantee(item.index);
    }
  },
};

const guaranteeTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;
    const sourceListId = monitor.getItem().listId;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Determine rectangle on screen
    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    // Determine mouse position
    const clientOffset = monitor.getClientOffset();

    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%

    // Dragging downwards
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }

    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }

    // Time to actually perform the action
    if (props.listId === sourceListId) {
      props.moveGuarantee(dragIndex, hoverIndex);

      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      monitor.getItem().index = hoverIndex;
    }
  },
};

GuaranteeLineItem.propTypes = {
  connectDragPreview: PropTypes.func,
  connectDragSource: PropTypes.func,
  connectDropTarget: PropTypes.func,
  isDragging: PropTypes.bool,
  guarantee: PropTypes.object,
  split: PropTypes.string,
};

export default flow(
  DropTarget("GUARANTEE", guaranteeTarget, (connect) => ({
    connectDropTarget: connect.dropTarget(),
  })),
  DragSource("GUARANTEE", guaranteeSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
  }))
)(GuaranteeLineItem);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/classes/GuaranteeLineItem.js